
import { useState } from "react"
import { ChevronDown, Building2, Scale, Users, Award } from "lucide-react"
import "./index.css"

export default function LegalAssociates() {
  const [expandedSection, setExpandedSection] = useState(null)

  const toggleSection = (section) => {
    setExpandedSection(expandedSection === section ? null : section)
  }

  return (
    <div className="container">
      <div className="header-legal fade-in">
        <h1>Details of Sponsors and Associated Companies</h1>
        <p>Legal and Administrative Information</p>
      </div>

      <div className="card fade-in">
        <div className="card-content">
          <div className="section-title">
            <Users className="icon" />
            <h2>Management Details</h2>
          </div>
          <div className="management-details">
            <p className="name">Mrs. Jamna Devi Reena Kumari</p>
            <p className="subtitle">(Details given in management profile)</p>
            <p className="associated">
              Associated Companies: <span>NIL</span>
            </p>
          </div>
        </div>
      </div>
      
      {/* Broker Rating -- N/A */}
      
      <div className="card fade-in">
        <div className="card-content">
          <div className="section-title">
            <Building2 className="icon" />
            <h2>Broker Rating</h2>
          </div>
          <p className="rating">N/A</p>
        </div>
      </div>

      

      <div className="card fade-in">
        <button onClick={() => toggleSection("auditors")} className="card-header">
          <div className="section-title">
            <Award className="icon" />
            <h2>Our Statutory/NCB Auditors</h2>
          </div>
          <ChevronDown className={`chevron ${expandedSection === "auditors" ? "rotate" : ""}`} />
        </button>
        <div className={`card-body ${expandedSection === "auditors" ? "expanded" : ""}`}>
          <div className="subsection">
            <h3>Ratings</h3>
            <p>SBP Category "A"</p>
            <p>QCR: Satisfactory</p>
          </div>
          <div className="subsection">
            <p className="company">Naveed Zafar Ashfaq Jaffery & Co.</p>
            <p>1st Floor Modern Motors House</p>
            <p>Beaumont Road Karachi</p>
            <p>Contact: +92-21-565-71209</p>
          </div>
        </div>
      </div>

      <div className="card fade-in">
        <button onClick={() => toggleSection("legal")} className="card-header">
          <div className="section-title">
            <Scale className="icon" />
            <h2>Legal Advisor</h2>
          </div>
          <ChevronDown className={`chevron ${expandedSection === "legal" ? "rotate" : ""}`} />
        </button>
        <div className={`card-body ${expandedSection === "legal" ? "expanded" : ""}`}>
          <p className="company">AFRAS & COMPANY</p>
          <p>Management Accountant and Capital Market Consultants</p>
          <p>Office No. 402, 4th Floor,</p>
          <p>Stock Exchange Building Karachi</p>
          <p>Contact: +92-21-345-1239</p>
        </div>
      </div>

      <div className="card fade-in">
        <button onClick={() => toggleSection("audit")} className="card-header">
          <div className="section-title">
            <Building2 className="icon" />
            <h2>Audit Committee</h2>
          </div>
          <ChevronDown className={`chevron ${expandedSection === "audit" ? "rotate" : ""}`} />
        </button>
        <div className={`card-body ${expandedSection === "audit" ? "expanded" : ""}`}>
          <div className="committee-member">
            <p className="role">Chairman:</p>
            <p className="name">Mr. Muhammad Hammad Arshad</p>
          </div>
          <div className="committee-member">
            <p className="role">Member:</p>
            <p className="name">Mrs. Jamna Devi Reena Kumari</p>
          </div>

        </div>
      </div>
    </div>
  )
}

